import { ButtonComponent } from '@/components/commons'
import { Text } from '@/components/commons/typography/Text'
import { Title } from '@/components/commons/typography/Title'
import { ModalPage } from '@/components/ui/modals/ModalPage.component'

interface RemoveConnectionProps {
  showModal: boolean
  closeModal: () => void
  removeConnection: () => void
  loading?: boolean
}

export const ModalRemoveConnection = ({
  showModal,
  closeModal,
  removeConnection,
  loading,
}: RemoveConnectionProps) => {
  return (
    <ModalPage show={showModal} onClose={closeModal}>
      <div className="flex flex-column gap-20">
        <Title
          sizeClass="text-16"
          weightClass="font-bold"
          className="text-center"
        >
          Remove Connection
        </Title>
        <Text>Are you sure that you want to remove this connection?</Text>
        <div className="pt-12 flex justify-flex-end gap-16">
          <ButtonComponent
            label="Cancel"
            variation="secondary"
            size="xSmall"
            onClick={closeModal}
            loading={loading}
          />
          <ButtonComponent
            label="Remove"
            size="xSmall"
            onClick={removeConnection}
            loading={loading}
          />
        </div>
      </div>
    </ModalPage>
  )
}
